import { mizukiCharacter } from '../../characters/mizuki/character.config';
import { odetteCharacter } from '../../characters/odette/character.config';

export const characterRegistry = { mizuki: mizukiCharacter, odette: odetteCharacter };
export type CharacterId = keyof typeof characterRegistry;
export type RegisteredCharacter = (typeof characterRegistry)[CharacterId];
export const characterList = Object.values(characterRegistry);
